import dayjs from 'dayjs'

import { apiRequest } from './client'

const changeDateFormat = (date) => {
    if (!date) return ''
    const parsed = dayjs(date, ['YYYY-MM-DD', 'DD.MM.YYYY'], true)
    return parsed.isValid() ? parsed.format('YYYY-MM-DD') : ''
}

export const scheduleApi = {
    getSemester: (filters) => {
        const {
            viewMode,
            selectedGroupId,
            selectedTeacherId,
            dateFrom,
            dateTo,
            selectedRoomId,
            selectedBuildId,
            selectedClassTypeId,
            selectedSubjectId,
            currentPage,
            pageSize,
        } = filters

        const filterQuery =
            viewMode === 'group'
                ? `group_id=${encodeURIComponent(selectedGroupId)}`
                : `teacher_id=${encodeURIComponent(selectedTeacherId)}`

        const dateQuery =
            dateFrom && dateTo
                ? `&date_from=${encodeURIComponent(changeDateFormat(dateFrom))}&date_to=${encodeURIComponent(changeDateFormat(dateTo))}`
                : ''

        let query = `${filterQuery}${dateQuery}`

        if (selectedRoomId) {
            query += `&room_id=${encodeURIComponent(selectedRoomId)}`
        } else if (selectedBuildId) {
            query += `&building_id=${encodeURIComponent(selectedBuildId)}`
        }

        if (selectedClassTypeId) {
            query += `&class_type_id=${encodeURIComponent(selectedClassTypeId)}`
        }

        if (selectedSubjectId) {
            query += `&subject_id=${encodeURIComponent(selectedSubjectId)}`
        }

        query += `&offset=${(currentPage - 1) * pageSize}&limit=${pageSize}`

        return apiRequest(`/schedule/semester?${query}`)
    },

    getForClasses: (classIds) =>
        apiRequest(`/schedule_for_classes?classes=${classIds}`),

    saveLesson: ({ lessonId, payload }) => {
        const path = lessonId ? `/schedule/lesson/${lessonId}` : '/schedule/lesson'
        const method = lessonId ? 'PUT' : 'PATCH'

        return apiRequest(path, {
            method,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        })
    },

    deleteLesson: (lessonId) =>
        apiRequest(`/schedule/lesson/${lessonId}`, { method: 'DELETE' }),

    checkOccupancy: ({ day, teacherId, groupIds, roomId }) => {
        const query = new URLSearchParams({ day })

        if (teacherId) {
            query.set('teacher_id', String(teacherId))
        }

        if (groupIds) {
            query.set('group_ids', groupIds)
        }

        if (roomId) {
            query.set('room_id', String(roomId))
        }

        return apiRequest(`/check_schedule?${query.toString()}`)
    },
}
